import {
	AcademicUserApi,
	AcademicUserProfilesResponseDTO,
	AuthApi,
	SwitchProfileResponseDTO,
} from "../Api";
import { getAuthConfiguration } from "./configuration";

const AuthApiFactory = () => new AuthApi(getAuthConfiguration());
const AuthAcademicUserApiFactory = () =>
	new AcademicUserApi(getAuthConfiguration());

export const getProfilesByCursId = async (
	cursId: number
): Promise<AcademicUserProfilesResponseDTO> => {
	return AuthAcademicUserApiFactory().apiAcademicUserGetProfilesByCursIdCursIdGet(
		{
			cursId,
		}
	);
};

export const switchProfile = async (
	targetProfileId: string
): Promise<SwitchProfileResponseDTO> => {
	const response =
		await AuthAcademicUserApiFactory().apiAcademicUserSwitchProfileTargetProfileIdPost(
			{
				targetProfileId,
			}
		);

	if (response.errorMessage) {
		throw new Error(response.errorMessage.message ?? "SwitchProfile failed");
	}

	if (!response.response?.token) {
		throw new Error("SwitchProfile failed: token missing in response");
	}

	return response.response;
};
